import { render, staticRenderFns } from "./ShareLinkTable.vue?vue&type=template&id=108a3152&scoped=true"
import script from "./ShareLinkTable.vue?vue&type=script&lang=js"
export * from "./ShareLinkTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108a3152",
  null
  
)

export default component.exports